// toolbar.js - Klick-Handler der Editor-Toolbar (Grammatik, Copy-to-Word, Logik, Format)

import { showLogicCheckPopup } from "./logic-check-popup.js";

// Set up the toolbar click handlers
export function setupToolbar(editorAPI) {
  // Grammar Check Button (now in header-buttons)
  const grammarCheckBtn = document.getElementById('btn-grammar-check');
  if (grammarCheckBtn) {
    grammarCheckBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const button = e.currentTarget;

      // Disable button during processing
      button.disabled = true;
      button.style.opacity = '0.5';
      button.style.cursor = 'wait';

      try {
        await editorAPI.checkGrammar();
      } finally {
        // Re-enable button
        button.disabled = false;
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
        editorAPI.view.focus();
      }
    });
  }

  // Copy to Word Button
  const copyToWordBtn = document.getElementById('btn-copy-to-word');
  if (copyToWordBtn) {
    copyToWordBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const button = e.currentTarget;

      // Disable button during processing
      button.disabled = true;
      button.style.opacity = '0.5';

      try {
        await editorAPI.copyToWord();
      } finally {
        // Re-enable button
        button.disabled = false;
        button.style.opacity = '1';
        editorAPI.view.focus();
      }
    });
  }

  // Logic Check Button (UltraThink with Claude Opus)
  const logicCheckBtn = document.getElementById('btn-logic-check');
  if (logicCheckBtn) {
    logicCheckBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const button = e.currentTarget;

      // Disable button during processing
      button.disabled = true;
      button.style.opacity = '0.5';

      try {
        const text = editorAPI.getText();
        if (!text || text.trim().length === 0) {
          alert('Bitte geben Sie zuerst Text ein.');
          return;
        }

        // Call the ultrathink MCP tool via the backend
        const response = await fetch('/api/mcp/tools/call', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            tool_name: 'ultrathink',
            params: {
              text: text
            }
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        // Display the analysis in a popup panel
        showLogicCheckPopup(result);

      } catch (error) {
        alert(`Fehler bei der Logikprüfung: ${error.message}`);
      } finally {
        // Re-enable button
        button.disabled = false;
        button.style.opacity = '1';
        editorAPI.view.focus();
      }
    });
  }
}
